import { analytics } from "./analyticsReducer";

export default analytics;